export default function OurClinic() {
  const features = [
    {
      num: '01',
      title: '3D-CTによる正確な診断',
      description: 'インプラント治療を開始する前には、あごの骨の状態や神経、血管の位置を正確に評価することが不可欠です。当院では、この重要な診断を支援するために歯科用CT、インプラント用ガイド、シミュレーションソフトウェアなどの先進的な設備を備えています。これにより、患者様には安全かつ安心して治療を受けていただける環境を提供しています。',
      image: 'https://static.readdy.ai/image/4d1e24136ef2955fabe2fc9c76951eeb/107309ef44ee9543fbc05dd5614d9d00.jpeg',
      align: 'left'
    },
    {
      num: '02',
      title: '痛みの少ない治療方法',
      description: 'コンピューター解析(サージカルガイド)により歯ぐきを切開せずに、フラップレスインプラントを採用しており、患者様の負担を最小限に抑えています。状態により従来の手術法を取る場合もあります。',
      image: 'https://public.readdy.ai/ai/img_res/250dc8819d0acd9b021de42b4ed3f946.jpg',
      align: 'right'
    },
    {
      num: '03',
      title: '実績豊富な医師が担当\n難症例にも対応可能',
      description: '数多くのインプラントの症例数を経験してきて様々なケースに対応が可能です。安心して処置を受けていただけるように心がけておりますので、まずはカウンセリングにてご相談ください。',
      image: 'https://static.readdy.ai/image/4d1e24136ef2955fabe2fc9c76951eeb/90b887cdc8605e4875316b8dbe6a078a.jpeg',
      align: 'left'
    },
    {
      num: '04',
      title: '10年の安心保証',
      description: '当院でのインプラント治療においては、インプラント本体に関する不具合が原因での再手術や代替治療が必要になった場合、治療から10年以内であれば追加費用は一切発生しません。11年目からは部分的な保証(30%保証)に移行しますが、これにより最長「20年の長期保証」を提供する保証システムを整えています。',
      image: 'https://readdy.ai/api/search-image?query=Premium%20warranty%20certificate%20with%20gold%20seal%20and%20elegant%20design%2C%20luxury%20guarantee%20document%2C%20sophisticated%20professional%20presentation%2C%20high-end%20quality%20assurance%2C%20trust%20and%20reliability%20symbol%2C%20refined%20aesthetic%20with%20gold%20accents&width=800&height=600&seq=warranty-cert-1&orientation=landscape',
      align: 'right'
    }
  ];

  return (
    <section id="our-clinic" className="py-24 bg-gradient-to-b from-slate-50 via-white to-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-block mb-6">
            <span className="text-sm font-bold text-amber-500 tracking-widest uppercase">Implants in our clinic</span>
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold mb-6 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 bg-clip-text text-transparent" style={{ fontFamily: '"Noto Serif JP", serif', letterSpacing: '0.02em' }}>
            ゆうまデンタルのインプラント
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 mx-auto"></div>
        </div>

        <div className="space-y-24">
          {features.map((feature, index) => (
            <div key={index} className={`grid lg:grid-cols-2 gap-12 lg:gap-16 items-center ${feature.align === 'right' ? 'lg:flex-row-reverse' : ''}`}>
              <div className={`relative group ${feature.align === 'right' ? 'lg:order-2' : ''}`}>
                <div className="absolute -top-8 -left-8 w-24 h-24 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-3xl flex items-center justify-center z-10 shadow-2xl group-hover:scale-110 transition-transform">
                  <span className="text-4xl font-bold text-white" style={{ fontFamily: '"Playfair Display", serif' }}>{feature.num}</span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-br from-amber-400/10 to-yellow-500/10 rounded-3xl blur-2xl group-hover:blur-3xl transition-all"></div>
                <img 
                  src={feature.image} 
                  alt={feature.title} 
                  className="relative w-full rounded-3xl shadow-2xl border border-slate-200 group-hover:shadow-3xl transition-shadow"
                />
              </div>
              <div className={`${feature.align === 'right' ? 'lg:order-1' : ''}`}>
                <div className="bg-white rounded-3xl p-10 shadow-xl border border-slate-200">
                  <h3 className="text-3xl lg:text-4xl font-bold mb-8 whitespace-pre-line bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent" style={{ fontFamily: '"Noto Serif JP", serif', letterSpacing: '0.02em' }}>
                    {feature.title}
                  </h3>
                  <div className="w-16 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 mb-8"></div>
                  <p className="text-lg text-slate-700 leading-relaxed font-light">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
